import { AppBar, AppBarProps, Box, IconButton, Toolbar, styled } from "@mui/material";
import React from "react";
import ContentSection from "./ContentSection";
import { MenuOutlined, PersonOutlined } from "@mui/icons-material";
import { IHeader } from "../../cms/interfaces/IHeader";
import SHLogo from "./SHLogo";
import { Link, useLocation } from "react-router-dom";

interface Props {
    toggleMenu: () => void,
    toogleLogin: () => void,
    headerSpecs?: IHeader
}

const StyledAppBar = styled(AppBar)<AppBarProps>(({theme}) => ({
    background: theme?.palette?.background?.default,
    padding: '1em',
    "& .c-page-title": {
        fontSize: '1.3em'
    }
}));

const Header : React.FC<Props> = ({toggleMenu, toogleLogin}) => {
    const location = useLocation();
    return <>
        <StyledAppBar position="static">
            <ContentSection>
                <Toolbar>
                    <IconButton onClick={toogleLogin}>
                        <PersonOutlined />
                    </IconButton>
                    <Box sx={{flexGrow: 1}}>
                        <Link to={`${location?.pathname?.startsWith("/de") ? "/de" : "/en"}`}>
                            <SHLogo />
                        </Link>
                    </Box>
                    <IconButton onClick={toggleMenu}>
                        <MenuOutlined />
                    </IconButton>
                </Toolbar>
            </ContentSection>
        </StyledAppBar>
    </>
}

export default Header;